module.exports = __webpack_public_path__ + "static/img/logo_sidamo.f69cedc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_sidamo.png
// module id = ufes
// module chunks = 1